AuthRoute = require 'mixins/authenticated-route'

App.CommunicationChannelsRoute = Em.Route.extend AuthRoute,
  model: ->
    @store.find 'communication-channel'
  actions:
    goBackToChannelsList: ->
      @transitionTo 'communication-channels'
      false
